import React from 'react';
import { Navigate, Outlet, type RouteObject, useLocation } from 'react-router';

import { Path } from '../../../enums';
import { useCan } from '../../hooks/useCan.ts';
import { type Guard } from './types';

type CanRouteProps = Guard & { to?: string };

export const CanRoute = ({ entity, action, to = Path.ErrorPage }: CanRouteProps) => {
  const { can } = useCan();
  const location = useLocation();
  return can(entity, action) ? (
    <Outlet />
  ) : (
    <Navigate
      to={to}
      replace
      state={{
        from: location,
        statusCode: 403,
        message: 'You do not have permission to view this page.',
      }}
    />
  );
};

/** Applies the same permission check to direct URLs and in-app navigation. */
export const guardRoute = (route: RouteObject, guard: Guard, to?: string): RouteObject => ({
  element: <CanRoute {...guard} to={to} />,
  children: [route],
});
